/**
 * Soft cursor follower. Desktop (hover + fine pointer) only, and skipped
 * entirely under prefers-reduced-motion — touch devices and motion-safe
 * users never see or pay for this.
 */
import { motionEnabled } from '@theme/premium-motion';

const supportsHover = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
const follower = document.querySelector('[data-flv-cursor]');

if (motionEnabled && supportsHover && follower && typeof gsap !== 'undefined') {
  document.body.classList.add('flv-cursor-active');

  const moveX = gsap.quickTo(follower, 'x', { duration: 0.5, ease: 'power3' });
  const moveY = gsap.quickTo(follower, 'y', { duration: 0.5, ease: 'power3' });

  window.addEventListener('mousemove', (event) => {
    moveX(event.clientX);
    moveY(event.clientY);
  });

  // Delegated on document (not per-element) so it keeps working for
  // elements added later — cart drawer updates, search results, etc.
  document.addEventListener('mouseover', (event) => {
    if (event.target instanceof Element && event.target.closest('a, button')) {
      follower.classList.add('is-active');
    }
  });
  document.addEventListener('mouseout', (event) => {
    if (event.target instanceof Element && event.target.closest('a, button')) {
      follower.classList.remove('is-active');
    }
  });
}
